import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["modal", "title", "description"]

  open(event) {
    event.preventDefault()

    this.form = event.currentTarget.closest("form")
    if (!this.form) return

    const query = event.currentTarget.dataset.query || "this keyword"
    const roleLabel = event.currentTarget.dataset.roleLabel || "apply this change"

    this.titleTarget.textContent = `${roleLabel}?`
    this.descriptionTarget.textContent = `Apply "${roleLabel}" to "${query}"? You can close this dialog if you want to review the suggestion first.`
    this.modalTarget.classList.remove("hidden")
  }

  close(event) {
    event?.preventDefault()
    this.modalTarget.classList.add("hidden")
    this.form = null
  }

  backdropClose(event) {
    if (event.target === this.modalTarget) {
      this.close()
    }
  }

  submit(event) {
    event.preventDefault()
    const form = this.form
    this.close()
    form?.requestSubmit()
  }
}
